import Vue from 'vue';
import FormComponent from '@app/components/Form.vue';
import BaseLocator from '@app/modules/RF/Locator/BaseLocator.vue';
export default Vue.extend({
    extends: BaseLocator,
    components: {
        FormComponent: FormComponent,
    },
    props: {
        block: Object
    }
});
